(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("date-time-picker", [], factory);
	else if(typeof exports === 'object')
		exports["date-time-picker"] = factory();
	else
		root["date-time-picker"] = factory();
})(this, function() {
return 